module.exports = __webpack_public_path__ + "img/aPlazo.e4e263cb.png";